import { useEffect, useState } from 'react';

/** Flat row indexes for grouped date sections. Date headers are not rows. */
export function assignLoupeIndexes(sections) {
  const indexes = new Map();
  let index = 0;
  (sections || []).forEach((section) => {
    (section.items || []).forEach((item) => {
      indexes.set(item, index);
      index += 1;
    });
  });
  return indexes;
}

/**
 * Desktop list loupe. Same scale, blur, and opacity as the sidebar.
 * `resetKey` clears the effect when the visible rows change.
 */
export default function useAdminListLoupe(resetKey) {
  const [loupeIndex, setLoupeIndex] = useState(null);

  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const apply = () => {
      if (!desktop.matches) setLoupeIndex(null);
    };
    apply();
    desktop.addEventListener('change', apply);
    return () => desktop.removeEventListener('change', apply);
  }, []);

  useEffect(() => {
    setLoupeIndex(null);
  }, [resetKey]);

  const focus = (index) => {
    if (window.innerWidth < 1024) return;
    setLoupeIndex(index);
  };

  const classFor = (index) => {
    if (loupeIndex == null || index == null) return '';
    const distance = Math.abs(index - loupeIndex);
    if (distance === 0) return 'admin-loupe-active';
    if (distance === 1) return 'admin-loupe-near';
    return 'admin-loupe-far';
  };

  return {
    active: loupeIndex != null,
    classFor,
    focus,
    clear: () => setLoupeIndex(null),
  };
}
